import React, { useEffect } from 'react';

export const useOutsideComponentClick = (
  ref: React.RefObject<HTMLInputElement>,
  clickOutside: () => void,
) => {
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        clickOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [clickOutside, ref]);
};
